export default __webpack_public_path__ + "static/media/robin_3.334ecd18.mp3";